import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { BreakPointsMedia } from '@picsart/design-system/foundation/responsive';
import { PositiveColors } from '@picsart/design-system/foundation/colors';

const useStyles = createUseStyles<string, { isFallback?: boolean; isMaximizer?: boolean }>(
  () => ({
    root: {
      padding: props => (props?.isMaximizer ? Spacings.s0 : [Spacings.s64, Spacings.s0]),
      margin: 'auto',
      maxWidth: 1320,
      position: 'relative',
      [BreakPointsMedia.LG]: {
        padding: [Spacings.s40, Spacings.s0],
      },
      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        padding: [Spacings.s64, Spacings.s0],
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        padding: [Spacings.s40, Spacings.s0],
      },
    },
    title: {
      display: '-webkit-box',
      lineClamp: 2,
      boxOrient: 'vertical',
      width: 'fit-content',
      maxWidth: 856,
      minWidth: 200,
      minHeight: 24,
      margin: [Spacings.s56, 'auto', Spacings.s0],
      textAlign: 'center',
      lineHeight: LineHeights.l36,
      color: PositiveColors.text.default,
      overflow: 'hidden',

      [BreakPointsMedia.LG]: {
        margin: [Spacings.s0, 'auto', Spacings.s32],
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        '-webkit-line-clamp': 3,
        margin: [Spacings.s0, 'auto', Spacings.s24],
      },

      '@media screen and (max-width: 767px)': {
        '-webkit-line-clamp': 4,
        margin: [Spacings.s0, 'auto', Spacings.s12],
        fontSize: FontSizes.s24,
        lineHeight: LineHeights.l32,
      },
    },
    header: {
      fontWeight: 'unset',
    },
    centeredContent: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
    },
    content: {
      display: 'flex',
      flexWrap: props => !props?.isMaximizer && 'wrap',
      justifyContent: 'space-between',
      margin: [Spacings.s0, 'auto'],
      listStyleType: 'none',
      columnGap: Spacings.s40,

      '&.thin': {
        maxWidth: '60%',
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        '&, &.thin': {
          maxWidth: props => !props?.isMaximizer && 456,
        },

        '&::-webkit-scrollbar': {
          display: 'none',
        },
        flexWrap: 'nowrap',
        overflow: 'scroll',
        columnGap: Spacings.s32,
      },
    },
    item: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: props => (props?.isFallback ? 150 : 202),
      maxWidth: props => (props?.isFallback ? 150 : 202),
      height: 'auto',
      margin: [Spacings.s0, 'auto'],

      [BreakPointsMedia.LG]: {
        '&&': {
          minWidth: 150,
          maxWidth: 150,
          height: 84,
        },
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        '&&': {
          minWidth: 144,
          maxWidth: 144,
          height: 88,
          flexWrap: 'nowrap',
          marginBottom: Spacings.s0,
          '&:not(:last-child)': {
            marginRight: Spacings.s8,
          },

          '& div': {
            width: '100%',
          },
        },
      },

      '& img': {
        maxHeight: 202,
      },
    },
    image: {
      display: 'block',
      width: '100%',
      minWidth: '100%',
      height: '100%',
      objectFit: 'contain',
    },

    // skeleton custom styles
    titleFallback: {
      minHeight: 30,
    },
  }),
  {
    name: 'featured-in',
  },
);

export default useStyles;
